export default "__VITE_ASSET__31a847ad__"